import { createContext, useContext } from "react";
const initialValue = {
    listBreadcrumbs: [],
    setBreadcrumbs: () => null
};
const LayoutContext = createContext(initialValue);
export const useLayoutContext = () => useContext(LayoutContext);
export default LayoutContext;
